import { render, staticRenderFns } from "./ChatAuthorMessage.vue?vue&type=template&id=0b7b4126&scoped=true"
import script from "./ChatAuthorMessage.vue?vue&type=script&lang=js"
export * from "./ChatAuthorMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatAuthorMessage.vue?vue&type=style&index=0&id=0b7b4126&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7b4126",
  null
  
)

export default component.exports